<template>
  <div class="wrap">
    <div class="userinfo_bar">
      <Avatar :src="userInfo.userimg" size="70" />
      <div class="level_bar">
        <template v-if="verConfig.useIngegrante">
          <div class="nickname">
            {{ userInfo.username ? userInfo.username : $t("newAdd.noLoginUserName") }}
          </div>
        </template>
        <template v-else>
          <div class="nickname">
            {{ userInfo.username ? userInfo.username : $t("newAdd.noLoginUserName") }}
          </div>
        </template>
        <div class="money">
          <!-- <div class="title">{{ $t("Home.WithdrawSu.Balance") }}</div> -->
          <div class="value">
            {{ $money(Number(userInfo.money) || "0") }}
          </div>
        </div>
      </div>
    </div>
    <div class="profile-menu" :aria-label="$t('profileMenu.ariaLabel')">
      <div class="profile-menu__item" @click="$router.push({ name: 'newWithdraw' })">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"
          aria-hidden="true">
          <rect x="3" y="6" width="18" height="12" rx="2"></rect>
          <path d="M3 10h18" stroke-linecap="round"></path>
        </svg>
        <span>{{ $t('profileMenu.withdraw') }}</span>
        <van-icon name="arrow" size="14" color="#cfd3da" />
      </div>

      <div class="profile-menu__item" @click="$router.push({ name: 'withdrawList' })">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"
          aria-hidden="true">
          <path d="M12 8v4l3 2"></path>
          <circle cx="12" cy="12" r="9"></circle>
        </svg>
        <span>{{ $t('profileMenu.withdrawHistory') }}</span>
        <van-icon name="arrow" size="14" color="#cfd3da" />
      </div>

      <div class="profile-menu__item" @click="$router.push({ name: 'walletList' })">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"
          aria-hidden="true">
          <path d="M3 10l9-5 9 5"></path>
          <path d="M5 10v8m4-8v8m6-8v8m4-8v8M3 20h18" stroke-linecap="round"></path>
        </svg>
        <span>{{ $t('profileMenu.bankInfo') }}</span>
        <van-icon name="arrow" size="14" color="#cfd3da" />
      </div>
      <div class="profile-menu__item" @click="$router.push({ name: 'Password' })">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"
          aria-hidden="true">
          <rect x="5" y="11" width="14" height="9" rx="2"></rect>
          <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
        </svg>
        <span>{{ $t('profileMenu.password') }}</span>
        <van-icon name="arrow" size="14" color="#cfd3da" />
      </div>
      <div class="profile-menu__item" @click="switchLansShow = true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"
          aria-hidden="true">
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M3 12h18M12 3c3 3.2 3 14.8 0 18M12 3c-3 3.2-3 14.8 0 18"></path>
        </svg>
        <span>{{ $t('profileMenu.language') }}</span>
        <van-icon name="arrow" size="14" color="#cfd3da" />
      </div>
    </div>
    <div class="logout">
      <div @click="logoutEvent" class="btn">
        {{ userInfo.token ? $t("My.logout") : $t("newAdd.Login") }}
      </div>
    </div>
    <van-action-sheet v-model="switchLansShow" :actions="lans" :cancel-text="$t('Button.cancle')"
      :description="$t('checkLans')" close-on-click-action @select="checkLans" />
    <!-- <van-popup v-model="withdrawalBoxShow" :close-on-click-overlay="false">
      <div class="withdrawal-content">
        <div class="withdrawal-title">{{ $t("mine.wtdAmt") }}</div>
        <div class="withdrawal-input">
          <span></span>
          <input type="number" :placeholder="$t('mine.wtdAmt')" v-model="withdrawalVal" />
        </div>
        <div class="withdrawal-other">
          <span>{{ $t("mine.avaBlc") }} {{ userInfo.point }}&nbsp;,</span>
          <p @click="handleAllWithdrawal">{{ $t("mine.allWtd") }}</p>
        </div>
        <div class="withdrawal-commit-btn">
          <span @click="handleWithdrawalCommit('close')">{{
            $t("mine.close")
          }}</span>
          <p @click="handleWithdrawalCommit('commit')">
            {{ $t("mine.commit") }}
          </p>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Image as VanImage,
  Dialog,
  Toast,
  Popup,
} from "vant";
import Tabbar from "@/components/Tabbar";
import { REQUEST_API } from "@/http/api"; // 引入封装的axios
import { GET_USER_INFP, editAvatar, withdrawalBalanceApi } from "@/api";
import { $get, $post } from "@/utils/request";
// 设置vant的多语言
import Cookies from "js-cookie";
import { countTime, getMyTime, deciTurnMoney } from "@/utils/tools";
import { GET_CONFIG_INFO, userinfo } from "../../api";
import { getLanguage, setLan, setLanguage, lans } from "../../i18n";
import SelectCurrency from "@/components/currencyPicker.vue";
import { mapGetters, mapActions } from "vuex";
import { Avatar } from "@tt/components";
export default {
  data() {
    // this.tools = [
    //   [
    //     {
    //       title: "mine.tools.commission",
    //       icon: "icon-weibiaoti5",
    //       name: "commission",
    //       func: () => {
    //         this.$router.push("CommissionRecord");
    //       },
    //     },
    //     // {
    //     //   title: "mine.tools.details",
    //     //   icon: "icon-jilu",
    //     //   func: () => {
    //     //     this.$router.push("AccountData");
    //     //   },
    //     // },
    //     {
    //       title: "mine.serviceTools.certify",
    //       icon: "icon-shenfenrenzheng",
    //       func: () => {
    //         this.$router.push("/Certification");
    //       },
    //     },
    //     {
    //       title: "mine.serviceTools.personal",
    //       icon: "icon-shenfenrenzheng-tianxieshenfenxinxi",
    //       func: () => {
    //         this.$router.push("PersonalCenter");
    //       },
    //     },
    //     {
    //       title: "address.title",
    //       icon: "icon-shenfenrenzheng",
    //       func: () => {
    //         this.$router.push("/Address")
    //       },
    //     },
    //     {
    //       title: "mine.serviceTools.invite",
    //       icon: "icon-24gl-heartPulse",
    //       func: () => {
    //         if (
    //           !this.userInfo.identity ||
    //           this.userInfo.identity.indexOf("agent") === -1
    //         ) {
    //           return Toast(this.$t("hint.inviteBanned"));
    //         }
    //         this.$router.push("inviteFriends");
    //       },
    //     },
    //   ],
    //   // [
    //   //   {
    //   //     title: "login.userAgreement",
    //   //     icon: "icon-daohangshuoming",
    //   //     func: () => {
    //   //       this.$router.push("/UserAgreement");
    //   //     },
    //   //   },
    //   //   {
    //   //     title: "mine.serviceTools.aboutUs",
    //   //     icon: "icon-gongsiguanli",
    //   //     func: () => {
    //   //       this.$router.push("Aboutus");
    //   //     },
    //   //   },
    //   // ],
    //   // [
    //   //   {
    //   //     title: "mine.serviceTools.lan",
    //   //     icon: "icon-lvzhou_yuyanqiehuan",
    //   //     isSwitchLans: true,
    //   //   },
    //   //   {
    //   //     title: "My.download",
    //   //     icon: "icon-xiazai",
    //   //     func: () => {
    //   //       if (localStorage.getItem("android")) {
    //   //         location.href = localStorage.getItem("android");
    //   //       } else {
    //   //         location.href = "http://www.baidu.com";
    //   //       }
    //   //     },
    //   //   },
    //   // ],
    // ];
    // this.company = [
    //   {
    //     img: require("@/assets/home/notice.png"),
    //     title: this.$t("home.title.notice"),
    //     pagePath: "Notice",
    //   },
    //   {
    //     img: require("@/assets/home/about.png"),
    //     title: this.$t("mine.serviceTools.aboutUs"),
    //     pagePath: "AboutUs",
    //   },
    // ];
    // this.serviceTools = [
    //   {
    //     colors: ["#f8d78b", "#f0a430"],
    //     title: "mine.serviceTools.certify",
    //     // icon: require("@/assets/mine/certify.png"),
    //     icon: "icon-cardid",
    //     func: () => {
    //       this.$router.push("/Certification");
    //     },
    //   },
    //   {
    //     colors: ["#eb645a", "#e75147"],
    //     title: "mine.serviceTools.personal",
    //     // icon: require("@/assets/mine/user.png"),
    //     icon: "icon-wode1",
    //     func: () => {
    //       this.$router.push("PersonalCenter");
    //     },
    //   },
    //   // {
    //   //   colors: ["#83b7f4", "#153ed7"],
    //   //   title: "mine.serviceTools.teamReport",
    //   //   icon: require("@/assets/mine/team.png"),
    //   //   func: () => {
    //   //     this.$router.push("team");
    //   //   },
    //   // },
    //   {
    //     colors: ["#92deb7", "#4cbf8e"],
    //     title: "mine.serviceTools.invite",
    //     // icon: require("@/assets/mine/icon_invite.png"),
    //     icon: "icon-yaoqing",
    //     func: () => {
    //       this.$router.push("inviteFriends");
    //     },
    //   },
    //   // {
    //   //   colors: ["#d576f7", "#8d38f4"],
    //   //   title: "mine.serviceTools.message",
    //   //   icon: require("@/assets/mine/message.png"),
    //   //   func: () => {
    //   //     this.$router.push("Message");
    //   //   },
    //   // },
    //   {
    //     colors: ["#d576f7", "#8d38f4"],
    //     title: "login.userAgreement",
    //     // icon: require("@/assets/mine/userAgreement.png"),
    //     icon: "icon-xiugai",
    //     func: () => {
    //       this.$router.push("/UserAgreement");
    //     },
    //   },
    //   // {
    //   //   colors: ["#f8d78b", "#f0a430"],
    //   //   title: "mine.serviceTools.address",
    //   //   icon: require("@/assets/mine/address.png"),
    //   //   func: () => {
    //   //     this.$router.push("Address");
    //   //   },
    //   // },
    //   {
    //     colors: ["#a4e8d7", "#63b5c7"],
    //     title: "mine.serviceTools.aboutUs",
    //     // icon: require("@/assets/mine/about.png"),
    //     icon: "icon-gongsidizhi",
    //     func: () => {
    //       this.$router.push("Aboutus");
    //     },
    //   },
    //   {
    //     colors: ["#4760ff", "#0dccff"],
    //     title: "My.service",
    //     // icon: require("@/assets/mine/service.png"),
    //     icon: "icon-kefu",
    //     func: () => {
    //       this.$api.toService();
    //       // this.$toast("This feature has not been developed!")
    //     },
    //   },
    //   // {
    //   //   colors: ["#eb645a", "#e75147"],
    //   //   title: "mine.serviceTools.inviteTask",
    //   //   icon: require("@/assets/mine/task.png"),
    //   //   func: () => {
    //   //     this.$router.push("InviteTask");
    //   //     // this.$toast("This feature has not been developed!")
    //   //   },
    //   // },
    //   // {
    //   //   colors: ["#6fbef8", "#388ff4"],
    //   //   title: "mine.serviceTools.security",
    //   //   icon: require("@/assets/mine/user.png"),
    //   //   func: () => {
    //   //     this.$router.push("Security");
    //   //   },
    //   // },
    //   // 切换语言
    //   {
    //     colors: ["#92deb7", "#83b7f4"],
    //     title: "mine.serviceTools.lan",
    //     // icon: require("@/assets/mine/lang.png"),
    //     icon: "icon-yuyan",
    //     func: () => {
    //       this.switchLansShow = true;
    //     },
    //   },
    //   {
    //     colors: ["#3fbbfe", "#a541ff"],
    //     title: "My.download",
    //     // icon: require("@/assets/mine/download.png"),
    //     icon: "icon-xiazaidaoru",
    //     func: () => {
    //       if (localStorage.getItem("android")) {
    //         location.href = localStorage.getItem("android");
    //       } else {
    //         location.href = "http://www.baidu.com";
    //       }
    //     },
    //   },
    // ];
    this.lans = lans;
    return {
      withdrawalBoxShow: false,
      withdrawalVal: null,
      country: Cookies.get("language"),
      language: "",
      // userInfo: {
      //   name: "",
      //   code: "",
      //   money: "0",
      //   url: "",
      // },
      // userInfo:{},
      money: "",
      test: {
        personal: "Personal information",
        preOrde: "Pre-order record",
        account: "Account details",
        recharge: "Recharge record",
        withdrawal: "Withdrawal record",
        invite: "Invite friends",
        announcement: "Announcement",
        team: "Team report",
        language: "Language setting",
      },
      gridItemArr: [
        {
          id: 1,
          url: require("@/assets/Img/myImg/Lark20220424-133047.png"),
          t: `add.Personalcenteraccountchangerecord`,
          flag: true,
          callBack: () => {
            this.$router.push("AccountData");
          },
        },
        {
          id: 2,
          url: require("@/assets/Img/myImg/Recharge.png"),
          t: `newTab.money`,
          flag: true,
          callBack: () => {
            this.$router.push("recharge-list");
          },
        },
        {
          id: 3,
          url: require("@/assets/Img/myImg/withdrawal.png"),
          t: `My.withdrawal`,
          flag: true,
          // t: this.$t("My.AccountRecord"),
          callBack: () => {
            if (this.$cookie.get("userInfo")) {
              this.$router.push("withdraw-list"); // 账户资料跳转-小饶
            } else {
              this.$toast(
                "You are not logged in. Please log in and try again!"
              );
            }
          },
        },
        {
          id: 4,
          url: require("@/assets/Img/myImg/personal-info.png"),
          t: `My.personal`,
          flag: true,
          callBack: () => {
            if (this.$cookie.get("userInfo")) {
              this.$router.push("PersonalCenter"); // 个人中心跳转-小饶
            } else {
              this.$toast(
                "You are not logged in. Please log in and try again!"
              );
            }
          },
        },
        {
          id: 5,
          url: require("@/assets/Img/myImg/kefu.png"),
          t: `mine.servier`,
          flag: true,
          callBack: () => {
            if (localStorage.getItem("service_url")) {
              // location.href = localStorage.getItem("service_url");
              this.$api.toService();
            } else {
              this.$toast("The call center is not online yet");
            }
          },
        },
        {
          id: 6,
          url: require("@/assets/Img/myImg/downT.png"),
          t: `My.download`,
          flag: this.$isDownloadFn,
          callBack: () => {
            if (this.$cookie.get("userInfo")) {
              if (localStorage.getItem("android")) {
                location.href = localStorage.getItem("android");
              } else {
                location.href = "http://www.baidu.com";
              }
            } else {
              this.$toast(
                "You are not logged in. Please log in and try again!"
              );
            }
          },
        },
        {
          id: 7,
          url: require("@/assets/Img/myImg/sharePink.png"),
          t: `My.invite`,
          flag: true,
          callBack: () => {
            // this.$router.push('InviteFriends') // 邀请好友跳转-小饶
            this.$router.push("inviteFriends");
          },
        },
        // {
        //   id: 7,
        //   url: require('@/assets/icon/myself/service.png'),
        //   t: `My.service`,
        //   callBack: () => {
        // this.$router.push('Announcement') // 系统公告-小饶
        // this.$api.toService()
        // },
        // },
        // {
        //   id: 8,
        //   url: require('@/assets/Img/myImg/Teamreport.png'),
        //   t: `My.team`,
        //   callBack: () => {
        //     this.$router.push('TheTeamReport') // 系统公告-小饶
        //   },
        // },
        /**
         * 语言修改
         */
        // {
        //   id: 9,
        //   url: require('../../assets/Img/myImg/language.png'),
        //   t: `My.language`,
        //   callBack: () => {
        //     this.show = true
        //   },
        // },
      ],
      show: false,
      levelText: "",
      shareUrl: "",
      switchLansShow: false,
      unit: "",
      rechargePath: this.verConfig.pathNewRecharge
        ? "third-recharge-n"
        : "new-recharge",
      // unitTitle: "USD",
    };
  },
  components: {
    Avatar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    // [Image.name]: VanImage,
    [Dialog.Component.name]: Dialog.Component,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    Tabbar,
    SelectCurrency,
    VanImage,
  },
  computed: {
    ...mapGetters(["userInfo", "unitData"]),
    totalBalance() {
      const res = Number(this.userInfo.money) + Number(this.userInfo.point);
      return !!res ? res.toFixed(2) : "0.00";
    },
    rateBalance() {
      const res =
        (Number(this.userInfo.money) + Number(this.userInfo.point)) /
        this.unitRate;
      return !!res ? res.toFixed(2) : "0.00";
    },
    unitTitle() {
      if (!this.unit) {
        return this.userInfo.currency_code || "";
      }
      const unitItem = this.unitData.find((item) => item.code === this.unit);
      return !!unitItem ? unitItem.title : "USD";
    },
    unitRate() {
      if (!this.unit) {
        const itemTemp = this.unitData.find(
          (item) => item.title === this.userInfo.currency_code
        );
        return !!itemTemp ? itemTemp.rate : 1;
      }
      const unitItem = this.unitData.find((item) => item.code === this.unit);
      return !!unitItem ? unitItem.rate : 1;
    },
  },
  methods: {
    handleTo(item) {
      this.$router.push(item.pagePath);
    },
    toService() {
      this.$api.toService();
    },
    handleClick(item) {
      if (item.isSwitchLans) {
        return (this.switchLansShow = true);
      }
      item.func();
    },
    async unitChange(value, index) {
      this.unit = value.code;
      // this.unitTitle = value.title;
      try {
        const {
          data: { ret, data, msg },
        } = await $post("/users/edit", { currency_code: value.code });
        if (ret == 1) {
          // this.$api.updateUserInfo();
          this.$store.dispatch("getUserInfo");
        }
      } catch (error) {
        console.log(error);
      }
    },
    // async getUnitData() {
    //   try {
    //     const {
    //       data: { ret, msg, data },
    //     } = await $get("/third/currency/rate");
    //     if (ret == 1) {
    //       this.unitData = data;
    //     }
    //   } catch (error) {}
    // },
    handleIntegralLink(type) {
      if (type === "balance") this.withdrawalBoxShow = true;
      else this.$router.push({ name: "AccountData", query: { type: "point" } });
    },
    handleAllWithdrawal() {
      const { point } = this.userInfo;
      if (this.withdrawalVal === point) return false;
      this.withdrawalVal = point;
    },
    handleWithdrawalCommit(type) {
      if (type === "close") {
        this.withdrawalBoxShow = false;
        this.withdrawalVal = null;
        return false;
      }
      const { point } = this.userInfo;
      if (
        !this.withdrawalVal ||
        point < this.withdrawalVal ||
        this.withdrawalVal <= 0
      )
        return Toast(this.$t("mine.wtdHint"));
      this.allWithdrawalApi();
    },

    async allWithdrawalApi() {
      const res = await withdrawalBalanceApi(this.withdrawalVal);
      const { ret, msg, data } = res.data;
      if (ret !== 1) return Toast(msg);

      this.getUserInfo();
      this.handleWithdrawalCommit("close");
    },
    //会员说明
    explain() {
      this.$router.push({ name: "levelUpgrade" });
    },
    handleLinkBill() {
      this.$router.push("bill-record"); // 个人中心跳转-小饶
    },
    async getShare() {
      const res = await GET_CONFIG_INFO({ act: "share" });
      const { data, ret, msg } = res.data;
      if (ret === 1) {
        this.shareUrl = data.text;
      }
    },
    copyShare() {
      this.$copyText(this.shareUrl).then(() => {
        Toast("success");
      });
    },
    toRecharge() {
      if (this.ver == "amigo_vi") {
        this.$router.push("/RechargeDesc");
        return;
      }
      if (this.verConfig.pathNewRecharge)
        this.$router.push({ name: "thirdRechargeNew" });
      else this.$router.push({ name: "NewRecharge" });
    },
    // 顶部导航栏的设置事件-小饶
    Personal() {
      if (this.$cookie.get("userInfo")) {
        this.$router.push("PersonalCenter");
      } else {
        this.$toast(this.$t("newAdd.NotLogin"));
      }
    },
    onClose() {
      this.show = false;
    },
    // 点击充值的按钮
    RechargeEvent() {
      this.$router.push(this.rechargePath);
    },
    // 点击提现按钮
    WithdrawEvent() {
      this.$router.push({ name: "newWithdraw" });
    },
    // 注销的按钮
    logoutEvent() {
      let _this = this;
      if (_this.userInfo.token) {
        Dialog.confirm({
          title: this.$t("My.quit"),
          message: this.$t("My.logoutEvent"),
          cancelButtonText: this.$t("My.Button.One"),
          confirmButtonText: this.$t("My.Button.Two"),
        })
          .then(() => {
            let pwdState = _this.$cookie.get("the-pwd-state");
            let pwdObj = _this.$cookie.get("the-pwd-obj");
            _this.$cookie.clear();
            _this.$cookie.set("the-pwd-state", pwdState);
            _this.$cookie.set("the-pwd-obj", pwdObj);
            _this.$router.push("/login");
            // window.location.reload()
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$router.push("/login");
      }
    },
    // 获取账户余额
    BalanceEvent() {
      let form = {
        cmd: "202445",
        uid: this.module.UIDEvent(),
      };
      REQUEST_API(form).then((res) => {
        this.$store.commit("SET_MONEY_INFO", res.data.notifyList[0].data);
        // this.money = res.data.notifyList[0].data.diamond
        this.money = deciTurnMoney(this.$store.state.user.moneyObj.diamond);
      });
    },
    getImageUrl(url) {
      const reg = new RegExp("http");
      if (reg.test(url)) return url;
      return this.verConfig.url + url;
    },
    // 获取用户信息
    getUserInfo() {
      // if (this.$cookie.get('userInfo')) {
      //   this.userInfo = JSON.parse(this.$cookie.get('userInfo'))
      // }
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo(
        (res) => {
          Toast.clear();

          this.userInfo = res;
          this.unit = res.currency_code || "USD";
        },
        (err) => {
          Toast.clear();
        }
      );
    },
    getUserInfo2() {
      GET_USER_INFP()
        .then((r) => {
          if (r.data.ret === 1) {
            this.$cookie.set("userInfo", JSON.stringify(r.data.data));
            this.$cookie.set("token", r.data.data.token);
            this.userInfo = r.data.data;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getDownloadUrl() {
      let url = {};
      let down = {
        id: 5,
        url: require("@/assets/icon/myself/download.png"),
        t: `My.download`,
        callBack: () => {
          window.location.href = url.android;
        },
      };
      this.$api.getNotice((res) => {
        if (res.appurl_android) {
          url.android = res.appurl_android;
          // this.gridItemArr.push(down);
        }
      });
    },
    checkLans(actions, index) {
      if (actions.value === getLanguage()) {
        this.switchLansShow = false;
        return;
      }
      this.$i18n.Locale = actions.value;
      this.changeLanguage(actions.value)
      setLanguage(actions.value);
      // location.reload();
    },
  },
  created() {
    this.$store.dispatch("getUserInfo")
  },
};
</script>

<style lang="less" scoped>
@Color: var(--theme);
@button-border-radius: 20px;
@background: var(--button-background);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.wrap {
  min-height: calc(100vh - 72px);
  background: var(--page-background);
  overflow: hidden;

  .userinfo_bar {
    display: flex;
    align-items: center;
    position: relative;
    gap: 10px;
    background: var(--nav-background);
    background-size: 100% 100%;
    padding: calc(12rem / 16) calc(20rem / 16);
    margin-bottom: 10px;

    .avatar {
      background-size: 100% 100%;
    }

    .level_bar {
      color: var(--color-text);
      font-size: calc(15rem / 16);

      .nickname {
        font-weight: 600;
      }
    }

    .money {
      display: flex;
      align-items: center;
      font-size: 16px;
      margin-top: 6px;
      color: var(--color-primary-strong);
    }
  }

  .money_bar {
    padding: calc(13rem / 16);

    >div {
      background-size: 100% 100%;
      border-radius: calc(8rem / 16);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(10rem / 16) calc(16rem / 16);
      padding-right: calc(9rem / 16);
      // color: #fff;
      margin-top: calc(13rem / 16);
      // background-color: var(--theme);
      background-color: #fff;
      color: #000;

      .title {
        color: #666;
      }

      &:nth-child(1) {
        // background-image: url("../../assets/mine/bg/2.png");
        margin-top: 0;
      }

      &:nth-child(2) {
        // background-image: url("../../assets/mine/bg/3.png");
      }

      &:nth-child(3) {
        // background-image: url("../../assets/mine/bg/4.png");
      }

      .left {
        >.title {
          font-size: calc(15rem / 16);
        }

        >.value {
          font-size: calc(18rem / 16);
          margin-top: calc(20rem / 16);
        }
      }

      .btns {
        display: flex;

        >div {
          &:active {
            opacity: 0.8;
          }

          // background: #fff;
          // color: #1200dc;
          // background: var(--theme);
          background: var(--nav-background);
          color: #fff;
          font-size: calc(12rem / 16);
          padding: calc(8rem / 16) calc(18rem / 16);
          border-radius: 99px;

          &:nth-child(2) {
            margin-left: calc(12rem / 16);
          }
        }
      }

      >.currencyPickerWrap {
        background: transparent;

        .iconfont {
          font-size: calc(28rem / 16);
          // color: #fff;
          // color: var(--theme);
        }
      }
    }
  }

  .group {
    margin-top: calc(10rem / 16);

    &:nth-child(1) {
      margin-top: 0;
    }

    .iconfont {
      font-size: calc(20rem / 16);
      margin-right: calc(8rem / 16);
    }
  }

  .profile-menu {
    margin: 0 20px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: var(--card-shadow);

    &__item {
      display: flex;
      align-items: center;
      padding: 14px;
      color: #333333;
      background: transparent;
      border: 0;
      font: inherit;
      font-size: 16px;
      text-align: left;

      & {
        border-bottom: 1px solid #eeeeee;
      }

      &:last-child {
        border-bottom: none;
      }

      >svg {
        width: 20px;
        height: 20px;
        flex: 0 0 auto;
        margin-right: 18px;
        color: var(--color-primary);
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      >span {
        min-width: 0;
        flex: 1;
        letter-spacing: 0;
      }
    }
  }

  .trade_bar {
    display: flex;
    margin: calc(13rem / 16);
    // margin-top: 0;
    justify-content: space-between;
    @gap: calc(15rem / 16);

    >div {
      width: calc((100% - @gap) / 2);
      height: calc(60rem / 16);
      border-radius: 10px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      >.iconfont {
        font-size: calc(30rem / 16);
      }

      >.text {
        font-size: calc(14rem / 16);
        // color: #000;
      }
    }

    .recharge {
      // color: #955f00;
    }

    .withdraw {
      // color: #04672d;
    }
  }

  .about_bar {
    .trade_bar();

    >div {
      border-radius: 6px;
      justify-content: flex-end;
      align-items: center;
      background-size: 100% 100%;

      >.title {
        font-size: calc(13rem / 16);
        padding: calc(6rem / 16) calc(8rem / 16);
        padding-left: calc(12rem / 16);
        background-color: #0271dc;
        color: #fff;
        border-top-left-radius: 90px;
        border-bottom-left-radius: 90px;
      }
    }
  }

  .logout {
    width: 85%;
    margin: 20vw auto;
    margin-top: calc(54rem / 16);
    // background-color: @Color;
    background: @background;
    margin-bottom: 20vw;
    padding: calc(12rem / 16) 0;
    color: var(--button-text);
    border-radius: 5px;

    .btn {
      text-align: center;
    }
  }

  .withdrawal-content {
    padding: calc(20rem / 16);
    border-radius: calc(6rem / 16);

    >.withdrawal-title {
      font-size: calc(20rem / 16);
      color: #aa9172;
    }

    >.withdrawal-input {
      margin: calc(14rem / 16) 0;

      >input {
        border: none;
        border-bottom: calc(1rem / 16) solid #000;
        font-size: calc(18rem / 16);
        padding-bottom: calc(5rem / 16);
      }
    }

    >.withdrawal-other {
      display: flex;
      font-size: calc(14rem / 16);

      >span {
        color: #9b9898;
      }

      >p {
        margin-left: calc(10rem / 16);
        color: #527eb4;
      }
    }

    >.withdrawal-commit-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: calc(20rem / 16);
      font-size: calc(16rem / 16);

      >span {
        color: #9b9898;
      }

      >p {
        margin-left: calc(20rem / 16);
        color: #527eb4;
      }
    }
  }
}
</style>
